<div *ngIf="sharedService.loading || loading">
  <div id="globalLoader" class="global-loader" [ngStyle]="{ 'background-color': sharedService.darkMode ? '#333' : '#fff' }">
    <h1>Loading</h1>
  </div>
</div>

<div fxLayout="column">
  <div *ngIf="!isEmbedded" fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <mat-card [style.background-color]="uiData.individual.color" fxFlex="100">
        <h2 class="noMarginHeader" style="display: flex; align-items: center;">
          <mat-icon>{{ individualApplicationTable.icon }}</mat-icon>&nbsp; My Individual Applications
        </h2>
      </mat-card>
    </div>
  </div>

  <mat-card>
    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
      <div fxLayout="row wrap" fxLayoutAlign="space-between start">
        <div fxLayoutGap="5px">
          <strong class="noMarginHeader">Results (<mat-spinner *ngIf="loading" diameter="15"></mat-spinner>{{ loading ? '' : filteredApplications.length }})</strong>

          <mat-form-field style="width: 220px;">
            <input (keyup)="filterTable()" placeholder="Filter applications" [(ngModel)]="filterString" matInput />
          </mat-form-field>

          <mat-form-field style="width: 180px;">
            <mat-select multiple placeholder="Filter by Status" [formControl]="selectedStatus" (selectionChange)="filterTable()">
              <mat-option *ngFor="let status of getStatusValues()" [value]="status">{{ status }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width: 180px;">
            <mat-select multiple placeholder="Filter by Type" [formControl]="selectedType" (selectionChange)="filterTable()">
              <mat-option *ngFor="let type of getApplicationTypeValues()" [value]="type">{{ getApplicationTypeLabel(type) }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width: 180px;">
            <input (dateChange)="filterTable()" matInput [matDatepicker]="applicationStartPicker" placeholder="Application Start Date" [formControl]="applicationDateFilterStart">
            <mat-datepicker-toggle matSuffix [for]="applicationStartPicker"></mat-datepicker-toggle>
            <button matSuffix mat-icon-button aria-label="Clear application start date" matTooltip="Clear application start date" (click)="applicationDateFilterStart.reset(); filterTable()">
              <mat-icon style="color: red;">close</mat-icon>
            </button>
            <mat-datepicker #applicationStartPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field style="width: 180px;">
            <input (dateChange)="filterTable()" matInput [matDatepicker]="applicationEndPicker" placeholder="Application End Date" [formControl]="applicationDateFilterEnd">
            <mat-datepicker-toggle matSuffix [for]="applicationEndPicker"></mat-datepicker-toggle>
            <button matSuffix mat-icon-button aria-label="Clear application end date" matTooltip="Clear application end date" (click)="applicationDateFilterEnd.reset(); filterTable()">
              <mat-icon style="color: red;">close</mat-icon>
            </button>
            <mat-datepicker #applicationEndPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="5px" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="start start">
          <button mat-raised-button (click)="clearFilters()">Reset Filters</button>
          <button mat-raised-button color="primary" title="Start A New Application" (click)="openStartApplication()">
            <mat-icon>add</mat-icon> Start A New Application
          </button>
        </div>
      </div>
      <br />

      <div *ngIf="loading" class="list-loading">
        <mat-spinner diameter="50"></mat-spinner>
      </div>

      <div *ngIf="!loading && !filteredApplications.length" class="empty-state">
        <mat-icon>assignment</mat-icon>
        <h3>No Matching Applications</h3>
        <p *ngIf="isEmbedded">This Individual does not currently have any user-scoped applications.</p>
        <p *ngIf="!isEmbedded">No user-scoped Individual applications matched the current filters. You can still start an application and choose a new or link workflow above.</p>
      </div>

      <mat-table *ngIf="!loading && filteredApplications.length" [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
        <ng-container *ngFor="let cellData of individualApplicationTable.layout.container" [matColumnDef]="cellData.columnName">
          <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]="isMobile ? { 'width': '100%', 'padding-left': '5px' } : {}">{{ cellData.displayName }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [matTooltip]="cellData.type === 'date' ? (getDateColumnValue(row, cellData.columnName) | date:'MM/dd/yyyy') : (cellData.type === 'status' ? getDisplayStatus(row) : getColumnText(row, cellData.columnName))" [matTooltipClass]="isCommentsColumn(cellData.columnName) ? 'multiline-tooltip' : ''" [ngStyle]="isMobile ? { 'width': '100%', 'padding-left': '5px' } : {}">
            <ng-container *ngIf="cellData.type === 'date'">
              <div *ngIf="isMobile" fxLayout="row">
                <span><strong>{{ cellData.displayName }}: </strong></span>&nbsp;
                <span>{{ getDateColumnValue(row, cellData.columnName) | date:'MM/dd/yyyy' }}</span>
              </div>
              <div *ngIf="!isMobile">
                {{ getDateColumnValue(row, cellData.columnName) | date:'MM/dd/yyyy' }}
              </div>
            </ng-container>
            <ng-container *ngIf="cellData.type !== 'date'">
              <ng-container *ngIf="cellData.type === 'status'; else applicationValue">
                <div class="status-card" [ngStyle]="{ '--status-color': statusColor(getDisplayStatus(row)) }">
                  <div *ngIf="isMobile" fxLayout="row">
                    <span><strong>{{ cellData.displayName }}: </strong></span>&nbsp;
                    <span>{{ getDisplayStatus(row) }}</span>
                  </div>
                  <div *ngIf="!isMobile">
                    {{ getDisplayStatus(row) }}
                  </div>
                </div>
              </ng-container>
              <ng-template #applicationValue>
                <div *ngIf="isMobile" fxLayout="row">
                  <span><strong>{{ cellData.displayName }}: </strong></span>&nbsp;
                  <span [ngClass]="{ 'comments-cell': isCommentsColumn(cellData.columnName) }" [style.white-space]="isCommentsColumn(cellData.columnName) ? 'pre-line' : 'normal'">{{ getColumnText(row, cellData.columnName) }}</span>
                </div>
                <div *ngIf="!isMobile" [ngClass]="{ 'comments-cell': isCommentsColumn(cellData.columnName) }" [style.white-space]="isCommentsColumn(cellData.columnName) ? 'pre-line' : 'normal'">
                  {{ getColumnText(row, cellData.columnName) }}
                </div>
              </ng-template>
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef [fxFlex]="'10'" [ngStyle]="isMobile ? { 'width': '100%', 'padding-left': '5px' } : {}">Actions</mat-header-cell>
          <mat-cell *matCellDef="let row" [fxFlex]="'10'" [ngStyle]="isMobile ? { 'width': '100%', 'padding-left': '5px' } : {}">
            <div *ngIf="isMobile" fxLayout="row" style="display: flex; justify-content: space-between; align-items: center;">
              <span><strong>Action: </strong></span>
              <button mat-icon-button color="primary" aria-label="Open individual application" matTooltip="Open individual application" (click)="openApplication(row); $event.stopPropagation()">
                <mat-icon>{{ isReadOnlyApplication(row) ? 'remove_red_eye' : 'edit' }}</mat-icon>
              </button>
            </div>
            <div *ngIf="!isMobile">
              <button mat-icon-button color="primary" aria-label="Open individual application" matTooltip="Open individual application" (click)="openApplication(row); $event.stopPropagation()">
                <mat-icon>{{ isReadOnlyApplication(row) ? 'remove_red_eye' : 'edit' }}</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="tableColumns"></mat-header-row>
        <mat-row fxLayout="row" fxLayout.lt-md="column" (click)="openApplication(row); $event.stopPropagation()" [ngClass]="sharedService.isMobile ? 'mobile-row' : ''" [ngStyle]="{ '--hover-bg-color': sharedService.hoverBackgroundColor }" *matRowDef="let row; columns: tableColumns"></mat-row>
      </mat-table>

      <br />
      <mat-paginator *ngIf="!loading && filteredApplications.length" [pageSize]="pageSize" [pageSizeOptions]="[10, 50, filteredApplications.length]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
    </div>
  </mat-card>
</div>